var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04001 0.836798C9.20242 0.887872 9.3443 0.989423 9.44501 1.12668C9.54572 1.26394 9.60003 1.42975 9.60001 1.6V5.6H12.8C12.9463 5.59993 13.0899 5.64001 13.215 5.71586C13.3402 5.79171 13.4421 5.90043 13.5098 6.03019C13.5774 6.15995 13.6082 6.30578 13.5987 6.45181C13.5892 6.59784 13.5399 6.73847 13.456 6.8584L7.85601 14.8584C7.75855 14.998 7.61908 15.1029 7.45789 15.1578C7.29669 15.2127 7.12219 15.2147 6.95977 15.1636C6.79735 15.1124 6.65548 15.0108 6.55481 14.8735C6.45413 14.7362 6.39991 14.5703 6.40001 14.4V10.4H3.20001C3.05368 10.4001 2.91013 10.36 2.78499 10.2841C2.65985 10.2083 2.55791 10.0996 2.49026 9.9698C2.42262 9.84004 2.39186 9.69421 2.40134 9.54819C2.41082 9.40216 2.46016 9.26153 2.54401 9.1416L8.14401 1.1416C8.24162 1.00223 8.38113 0.897608 8.54225 0.842939C8.70338 0.78827 8.87775 0.786399 9.04001 0.837598V0.836798Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBolt);
export default __webpack_public_path__ + "static/media/LightningBolt.106e83a2d866b198222da0f14b20dac2.svg";
export { ForwardRef as ReactComponent };